import React from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnProps } from 'antd/lib/table';
import numeral from 'numeral';
import dayjs from 'dayjs';

import Table from 'components/next/Table/Table';
import config from 'config/config';
import { DaysStatisticsDto } from 'types/dto/contracts-service';

interface Props {
  data: DaysStatisticsDto[];
  currency: string;
}

const ByMonthTable = ({ data, currency }: Props) => {
  const { t } = useTranslation();

  const columns: ColumnProps<DaysStatisticsDto>[] = [
    {
      title: t('dashboard_extend.byMonth.date'),
      key: 'signDate',
      render: (_, record) => dayjs(record.signDate).format(config.format.date),
    },
    {
      title: t('dashboard_extend.byMonth.countContracts'),
      key: 'countContracts',
      render: (_, record) => record.countContracts,
    },
    {
      title: t('dashboard_extend.byMonth.contractPaymentSum'),
      key: 'contractPaymentSum',
      render: (_, record) => `${numeral(record.contractPaymentSum).format(config.format.financial)} ${currency}`,
    },
    {
      title: t('dashboard_extend.byMonth.countClaims'),
      key: 'countClaims',
      render: (_, record) => record.countClaims,
    },
    {
      title: t('dashboard_extend.byMonth.claimPaymentSum'),
      key: 'claimPaymentSum',
      render: (_, record) => `${numeral(record.claimPaymentSum).format(config.format.financial)} ${currency}`,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={record => record.signDate ?? ''}
      scroll={{ x: 500, y: 265 }}
      pagination={false}
    />
  );
};

const Memoized = React.memo(ByMonthTable);

export default Memoized;
